import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, Accessibility } from 'lucide-react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#1e3a5f] text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="/Lone_Star_Republic_Consulting-2.png"
              alt="Lone Star Republic Consulting"
              className="h-14 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Clear guidance on cybersecurity, AI, and compliance for West Texas organizations.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/public-entities" className="text-gray-300 hover:text-white text-sm transition-colors">
                  For Public Entities
                </Link>
              </li>
              <li>
                <Link to="/small-business" className="text-gray-300 hover:text-white text-sm transition-colors">
                  For Small Business
                </Link>
              </li>
              <li>
                <Link to="/how-we-work" className="text-gray-300 hover:text-white text-sm transition-colors">
                  How We Work
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Get In Touch</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <MapPin size={18} className="text-[#c84630] mt-1 mr-2 flex-shrink-0" aria-hidden="true" />
                <p className="text-gray-300 text-sm">
                  Serving Abilene and West Texas
                </p>
              </div>
              <div className="flex items-start">
                <Phone size={18} className="text-[#c84630] mt-1 mr-2 flex-shrink-0" aria-hidden="true" />
                <a 
                  href="tel:325-305-2777" 
                  className="text-gray-300 hover:text-white text-sm transition-colors"
                >
                  325-305-2777
                </a>
              </div>
              <div className="flex items-start">
                <Mail size={18} className="text-[#c84630] mt-1 mr-2 flex-shrink-0" aria-hidden="true" />
                <a 
                  href="mailto:hello@lonestarrepublicco.com" 
                  className="text-gray-300 hover:text-white text-sm transition-colors"
                >
                  hello@lonestarrepublicco.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Accessibility Compliance Statement */}
        <div className="border-t border-gray-700 mt-8 pt-6">
          <div className="flex flex-col items-center text-center">
            <div className="flex items-start justify-center mb-3">
              <Accessibility size={16} className="text-gray-500 mr-2 mt-0.5 flex-shrink-0" aria-hidden="true" />
              <p className="text-gray-500 text-xs leading-relaxed max-w-2xl">
                This website is designed to meet Texas Administrative Code (TAC) §206 and WCAG 2.2 Level AA accessibility standards. 
                We prioritize accessibility so public organizations can confidently engage with us.
              </p>
            </div>
            <Link 
              to="/accessibility" 
              className="text-gray-400 hover:text-white text-xs transition-colors underline underline-offset-2"
            >
              Accessibility Conformance Report (WCAG 2.2 AA)
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-6 pt-6 text-center">
          <p className="text-gray-400 text-sm mb-2">
            &copy; {year} Lone Star Republic Consulting. All rights reserved.
          </p>
          <Link 
            to="/privacy-policy" 
            className="text-gray-500 hover:text-white text-xs transition-colors"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
